module.exports = __webpack_public_path__ + "assets/img/close.6df06400.svg";